var map = {
	"./Course-Icons1.svg": 2259,
	"./Course-Icons10.svg": 2260,
	"./Course-Icons11.svg": 2261,
	"./Course-Icons2.svg": 2262,
	"./Course-Icons3.svg": 2263,
	"./Course-Icons4.svg": 2264,
	"./Course-Icons5.svg": 2265,
	"./Course-Icons6.svg": 2266,
	"./Course-Icons7.svg": 2267,
	"./Course-Icons8.svg": 2268,
	"./Course-Icons9.svg": 2269
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2258;